import React from 'react';
import PropTypes from "prop-types";
import moment from "moment";

import Button from "../../components/buttons/button";
import {createErrorList, hasErrors} from "../../components/form/createErrorList";
import DateTimePickerField from "../../components/flatpickr-node/dateTimePickerField";

const ReportingSearchForm = ({config}) => {
    let startDate = null;
    if(config.reportingSearchCriteria.StartDate)
        startDate = moment(config.reportingSearchCriteria.StartDate).format("YYYY-MM-DD");

    let endDate = null;
    if(config.reportingSearchCriteria.EndDate)
        endDate = moment(config.reportingSearchCriteria.EndDate).format("YYYY-MM-DD");

    return (
        <form onSubmit={config.onSearchSubmit} >
                <div>
                    {config.hasSubmitted && hasErrors(config.errors) &&
                    <div className="text-danger">
                        <p>Please correct the issues as specified.</p>
                        {createErrorList(config.errors)}
                    </div>
                    }
                    <div className={"input-bottom-alignment"}>
                        <div className={"grid-x grid-padding-x align-bottom"}>
                            <div className={"cell medium-3 large-3"}>
                                <DateTimePickerField config={{
                                    name: "StartDate",
                                    label: "Start Date:",
                                    error: (config.hasSubmitted && config.errors.StartDate) ? "*" : "",
                                    enableTime: false,
                                    dateFormat: "m-j-Y",
                                    showLabel: true,
                                    value: startDate,
                                    inputClass: "margin-bottom-0",
                                    onChange: config.onDateChange
                                }}
                                />
                            </div>
                            <div className={"cell medium-3 large-3"}>
                                <DateTimePickerField config={{
                                    name: "EndDate",
                                    label: "End Date:",
                                    error: (config.hasSubmitted && config.errors.EndDate) ? "*" : "",
                                    enableTime: false,
                                    dateFormat: "m-j-Y",
                                    showLabel: true,
                                    value: endDate,
                                    inputClass: "margin-bottom-0",
                                    onChange: config.onDateChange
                                }}
                                />
                            </div>
                            <div className={"cell medium-3 large-3"}>
                                <div className={"button-group"}>
                                    <Button config={{
                                        name: "btnSearchReportingInfo",
                                        label: "Update",
                                        disabled: config.isLoading
                                    }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </form>
    );
};

ReportingSearchForm.propTypes = {
    config: PropTypes.shape({
        onSearchSubmit: PropTypes.func.isRequired,
        isLoading: PropTypes.bool.isRequired,
        hasSubmitted: PropTypes.bool.isRequired,
        errors: PropTypes.object,
        reportingSearchCriteria: PropTypes.object,
        onDateChange: PropTypes.func.isRequired
    })
};

export default ReportingSearchForm;